import classnames from "classnames"
import { useState } from "react"
import { isServer } from "@lib/isomorphic"
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { PostElementBackground } from "@serializers/article"
import { ShareButton } from "@ui"

interface ArticleShareProps {
  background: PostElementBackground
}

export const ArticleShare = observer(function ArticleShare(
  props: ArticleShareProps,
) {
  const [isTooltipOpened, setTooltipOpened] = useState(false)
  const {
    BlogModel: { postDetails },
    GlobalModel: { getTemplate },
  } = useStore()

  const tooltipClassnames = classnames(
    "fixed top-24 px-6 py-3 text-white font-bold bg-black z-70 rounded-md text-[18px] w-[250px] left-[calc(50%-125px)] text-center",
    {
      "opacity-0": !isTooltipOpened,
      "opacity-100": isTooltipOpened,
      "transition-opacity pointer-events-none": true,
    },
  )
  const sectionClassnames = classnames(
    "pt-6 pb-16 w-full tablet:pt-8 tablet:pb-18 desktop:pb-20 mt-[-1px]",
  )

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href)
    setTooltipOpened(true)
    setTimeout(() => setTooltipOpened(false), 5000)
  }

  const handleShare = async () => {
    if (isServer()) return

    const shareData = {
      title: postDetails?.meta_title || postDetails?.title || "",
      text: postDetails?.meta_description || "",
      url: window.location.href,
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (error) {
        handleCopy()
      }
    } else {
      handleCopy()
    }
  }

  return (
    <section className={sectionClassnames}>
      <div className={tooltipClassnames}>{getTemplate("copied")}</div>
      <div className="container space-y-6 w-full desktop:space-y-8">
        <div className="flex items-center tablet:flex-row flex-col">
          <div className="flex justify-between tablet:justify-start w-full tablet:w-auto">
            <ShareButton
              background={props.background}
              onClick={handleShare}
              text={getTemplate("share_article")}
            />
          </div>
        </div>
      </div>
    </section>
  )
})
